import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const wishlistCreation = async (payload) => {
  try {
    const response = await APIs.post(`/create_wish_list`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getWishList = async () => {
  try {
    const response = await APIs.get(`/get_all_wish_list`, {
      params: {}, // ensures Axios treats it as a valid config
      silent: true, // custom flag to suppress toast
    });

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    return null;
  }
};

const getSingleWishList = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_wish_list/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const clearWishList = async (payload) => {
  try {
    const response = await APIs.post(`/delete_wish_list`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const removeWishList = async (payload) => {
  try {
    const response = await APIs.patch(
      `/edit_wish_list/${payload?.cartId}`,
      payload
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const wishlistServices = {
  wishlistCreation,
  getWishList,
  getSingleWishList,
  clearWishList,
  removeWishList,
};

export default wishlistServices;
